import React from 'react'
import { HeaderD } from './HeaderStyled'
import Tab from './tab/Tab'
import { HeaderProps } from './interfaces'
import Close from 'components/header/pageHeader/Close'

export default function Header({
  handleAbove,
  handleActive,
  active,
  colors: { primary, secondaryBackground },
  audio,
}: HeaderProps) {
  return (
    <HeaderD
      data-testid='headerD'
      strokeColor={primary}
      backgroundColor={secondaryBackground}
      borderColor={primary}
    >
      {['my', 'all', 'high'].map(el => (
        <Tab
          name={el}
          key={el}
          active={active}
          handleActive={handleActive}
          activeColor={secondaryBackground}
          inactiveColor={primary}
        />
      ))}
      <Close handleAbove={handleAbove} audio={audio} />
    </HeaderD>
  )
}
